import axios from 'axios'
import { ElMessage } from 'element-ui' // 若用其他UI库，替换为对应提示组件

// 1. 创建axios实例，配置基础参数
const service = axios.create({
  //baseURL: '/api',
  baseURL: process.env.VUE_APP_BASE_API, // 替换为你的实际后端接口前缀
  timeout: 10000, // 请求超时时间（10秒）
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded' // 默认请求头
  }
})

// 2. 请求拦截器：发送请求前的处理（如添加token、拼接参数等）
service.interceptors.request.use(
  (config) => {
    // 示例：如果有登录token，添加到请求头（根据你的后端要求调整）
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  (error) => {
    // 请求错误的统一处理
    console.error('请求拦截器错误：', error)
    ElMessage.error('请求发送失败，请稍后重试')
    return Promise.reject(error)
  }
)

// 3. 响应拦截器：接收响应后的统一处理（适配你的接口返回格式）
service.interceptors.response.use(
  (response) => {
    const res = response.data // 取出接口返回的原始数据

    // 适配你的接口返回规则：code=200为成功，其他为失败
    if (res.code !== 200) {
      ElMessage.error(res.message || '接口请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // 成功时直接返回data层（简化业务层调用）
      return res.data
    }
  },
  (error) => {
    // 网络错误/超时等异常处理
    console.error('响应拦截器错误：', error)
    const errMsg = error.message || '网络异常，请检查网络连接'
    ElMessage.error(errMsg)
    return Promise.reject(error)
  }
)

// 5. 导出axios实例（如需自定义请求可直接用）
export default service